import type { Node } from '@xyflow/react'

/**
 * Topologically sort nodes so that parent nodes always come before their children.
 * React Flow requires this ordering for correct group/section rendering.
 */
export function sortParentsFirst(nodes: Node[]): Node[] {
  const nodeMap = new Map(nodes.map(n => [n.id, n]))
  const visited = new Set<string>()
  const result: Node[] = []

  function visit(id: string) {
    if (visited.has(id)) return
    visited.add(id)
    const node = nodeMap.get(id)
    if (!node) return
    if (node.parentId) visit(node.parentId)
    result.push(node)
  }

  for (const n of nodes) visit(n.id)
  return result
}
